import { useHistory } from 'react-router-dom'
import {
  EnumTipoAgrupacion,
  EnumTipoCicloFacturacion,
  EnumTipoFacturacion,
  EnumTipoRefacturacion,
  EnumTipoSujeto
} from '../../../api'
import { NonAuthRoutes } from '../../../model'

interface NavigateToSettlementsInvoicesParams {
  executionCycleId: number
  invoiceCycleId?: number
  invoiceCycleType?: EnumTipoCicloFacturacion
  subjectType?: EnumTipoSujeto
  billingType?: EnumTipoFacturacion
  isFinishedExecutionCycle?: boolean
  reInvoiceType?: EnumTipoRefacturacion
  groupingType?: EnumTipoAgrupacion
}

/**
 * Hook que maneja la navegación a la página de SettlementsInvoices.
 * Solo navega: el paso a PdteValidarFacturas lo decide el back al procesar el lote de facturación.
 *
 * @returns Función navigateToSettlementsInvoices para navegar a la página
 */
export const useNavigateToSettlementsInvoices = () => {
  const history = useHistory()

  const navigateToSettlementsInvoices = (params: NavigateToSettlementsInvoicesParams) => {
    history.push(NonAuthRoutes.SettlementsInvoices, {
      executionCycleId: params.executionCycleId,
      invoiceCycleId: params.invoiceCycleId,
      invoiceCycleType: params.invoiceCycleType,
      subjectType: params.subjectType,
      billingType: params.billingType,
      finishedExecutionCycle: params.isFinishedExecutionCycle,
      reInvoiceType: params.reInvoiceType,
      groupingType: params.groupingType
    })
  }

  return { navigateToSettlementsInvoices }
}
